import React from 'react'

import { NestedProjectGridPreview } from '../NestedProjectGridPreview'

import { HighlightedText, Skeleton } from '@sketch/components'

import NestedProjectShareDrop from '../NestedProjectShareDrop'

import {
  StyledName,
  StyledSubtitleTextWrapper,
  Container,
  GridWrapper,
  GridWrapperLeft,
  GridWrapperRight,
  GridNestedProjectItemOption,
  SelectedShadowWrapper,
  SelectedShadow,
} from './NestedProjectItem.styles'

// Shared
// This component shares the same util as ProjectItem
import { getButtonProps } from '../../../shares/components/ProjectItem/utils'
import { PreviewSubtitle } from './PreviewSubtitle'

import { NestedProjectItemProps } from './types'
import { useSearch } from '@sketch/utils'
import { isNestedProject } from '../../../shares/components/ShareActionsDropdown'
import { useFlag } from '@sketch/modules-common'
import {
  SelectedCheckbox,
  SelectedCheckboxFloatingWrapper,
} from '../../../shares/components/DocumentItem/DocumentItem.styles'

export const NestedProjectItemGridView = (props: NestedProjectItemProps) => {
  const {
    className,
    renderDropdown,
    onClick,
    nestedProject,
    workspaceIdentifier,
    disabledDrag,
    selected,
    onSelectChange,
    showSelectionCheckbox,
  } = props

  const isMultipleSelectionOn = useFlag('multiple-selection')

  const a11yProps = onClick ? getButtonProps(onClick) : {}
  const dropdownContent = renderDropdown?.()

  const { search } = useSearch()
  const name = nestedProject.name

  if (!isNestedProject(nestedProject)) return null

  return (
    <Container data-project-id={nestedProject.identifier}>
      <NestedProjectShareDrop
        projectIdentifier={nestedProject.identifier}
        workspaceIdentifier={workspaceIdentifier}
        disabledDrag={disabledDrag}
      >
        <GridWrapper
          className={className}
          title={nestedProject.name}
          $isSelected={selected}
          $showSelectionCheckbox={showSelectionCheckbox}
          {...a11yProps}
        >
          {isMultipleSelectionOn && (
            <SelectedCheckboxFloatingWrapper
              onClick={event => event.stopPropagation()}
            >
              <span className="sr-only">
                {selected ? 'Unselect project' : 'Select project'}
              </span>
              <SelectedCheckbox
                type="checkbox"
                checked={selected}
                onChange={event => onSelectChange?.(event.target.checked)}
              />
            </SelectedCheckboxFloatingWrapper>
          )}

          <NestedProjectGridPreview nestedProject={nestedProject} />

          <GridWrapperRight>
            <StyledName>
              <HighlightedText search={search}>{name}</HighlightedText>
            </StyledName>
            <StyledSubtitleTextWrapper>
              <PreviewSubtitle
                nestedProjectsCount={nestedProject.nestedProjectsCount}
                sharesCount={nestedProject.sharesCount}
              />
            </StyledSubtitleTextWrapper>
          </GridWrapperRight>
          {dropdownContent && (
            <GridNestedProjectItemOption aria-label="Document Options">
              {dropdownContent}
            </GridNestedProjectItemOption>
          )}

          {selected && (
            <SelectedShadowWrapper>
              <SelectedShadow />
            </SelectedShadowWrapper>
          )}
        </GridWrapper>
      </NestedProjectShareDrop>
    </Container>
  )
}

export interface NestedProjectItemGridViewSkeletonProps {
  inViewListener?: React.ReactNode
}
export const NestedProjectItemGridViewSkeleton = (
  props: NestedProjectItemGridViewSkeletonProps
) => {
  const { inViewListener } = props
  return (
    <Container>
      <GridWrapper>
        <GridWrapperLeft />
        <GridWrapperRight>
          <StyledName>
            <Skeleton width="75%" height="14px" />
          </StyledName>
          <StyledSubtitleTextWrapper>
            <Skeleton width="30%" height="12px" />
            {inViewListener}
          </StyledSubtitleTextWrapper>
        </GridWrapperRight>
      </GridWrapper>
    </Container>
  )
}
